export default __webpack_public_path__ + "static/media/bg-1.9ff47c14.webp";